import { render } from "./SelecaoLocalDeposito.vue?vue&type=template&id=2aa397a8&scoped=true"
import script from "./SelecaoLocalDeposito.vue?vue&type=script&lang=js"
export * from "./SelecaoLocalDeposito.vue?vue&type=script&lang=js"

import "./SelecaoLocalDeposito.vue?vue&type=style&index=0&id=2aa397a8&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa397a8"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
